function normalizeUserRole(role) {
  if (!role) {
    return "";
  }
  return String(role).trim().toLowerCase().replace(/\s+/g, "_");
}

/** Executive portfolio dashboards — hidden from operational roles in sidebar / direct URL. */
export const EXECUTIVE_DASHBOARD_ROUTE_KEYS = [
  "dashboard/overview",
  "dashboard/key-metrics",
  "dashboard/executive",
];

/**
 * Credora route keys hidden per role (sidebar + CredoraAccessGate).
 * Keys match CREDORA_PATH_PERMISSIONS (no layout slug).
 */
export const ROLE_HIDDEN_MENU_ROUTE_KEYS = {
  loan_officer: EXECUTIVE_DASHBOARD_ROUTE_KEYS,
  credit_analyst: EXECUTIVE_DASHBOARD_ROUTE_KEYS,
  collections_officer: [
    ...EXECUTIVE_DASHBOARD_ROUTE_KEYS,
    "dashboard/loan-officer",
    "dashboard/compliance",
    "dashboard/communications",
  ],
  call_center_agent: [
    ...EXECUTIVE_DASHBOARD_ROUTE_KEYS,
    "dashboard/loan-officer",
    "dashboard/compliance",
    "dashboard/communications",
  ],
  customer_support_agent: [
    ...EXECUTIVE_DASHBOARD_ROUTE_KEYS,
    "dashboard/loan-officer",
    "dashboard/collections",
    "dashboard/compliance",
  ],
  cashier: [
    ...EXECUTIVE_DASHBOARD_ROUTE_KEYS,
    "dashboard/collections",
    "dashboard/compliance",
    "dashboard/communications",
    "dashboard/call-center",
  ],
};

export function isRouteHiddenForRole(user, routeKey) {
  if (!user?.role || !routeKey) {
    return false;
  }
  const hidden = ROLE_HIDDEN_MENU_ROUTE_KEYS[normalizeUserRole(user.role)];
  return Boolean(hidden?.includes(routeKey));
}

/** Credora route keys (no layout slug) for each role's post-login landing page. */
export const ROLE_HOME_ROUTE_KEYS = {
  super_admin: "dashboard/executive",
  branch_manager: "dashboard/today-activity",
  loan_officer: "dashboard/loan-officer",
  credit_analyst: "loans/pending",
  collections_officer: "collections",
  call_center_agent: "dashboard/call-center",
  cashier: "finance/disbursements",
  customer_support_agent: "dashboard/call-center",
  auditor: "dashboard/compliance",
  read_only_viewer: "dashboard/executive",
};

/**
 * Resolve role-specific home path when access check passes.
 * @param {object} params
 * @param {object|null} params.user
 * @param {string} params.layoutSlug
 * @param {string} params.pub
 * @param {(user: object, path: string) => boolean} params.canAccess
 * @returns {string|null} Full path with layout slug, or null when no role home applies.
 */
export function resolveRoleHomePath({ user, layoutSlug, pub, canAccess }) {
  const role = normalizeUserRole(user?.role);
  const routeKey = ROLE_HOME_ROUTE_KEYS[role];
  if (!routeKey) {
    return null;
  }
  const path = `${pub}/credora/${routeKey}`;
  if (!canAccess(user, path)) {
    return null;
  }
  return `${path}/${layoutSlug}`;
}
